export default __webpack_public_path__ + "styles/icons/icon_2500LBottle.svg";